import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { AuthModule } from './common/auth';
import { HttpClientModule } from '@angular/common/http';
import { MigrationModule } from './pages/migration/migration.module';
import { IonicModule } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule.forRoot({
      region: environment.region,
      userPoolId: environment.userPoolId,
      userPoolWebClientId: environment.clientId,
    }),
    HttpClientModule,
    MigrationModule,
    BrowserAnimationsModule,
    IonicModule.forRoot()
  ],
  providers: [
    StatusBar,
    SplashScreen
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
